import { InjectionToken } from '@angular/core';
import { Proj4Fn } from './sheet-geo';

let loading: Promise<Proj4Fn> | null = null;

/** proj4js on first use only: a dynamic import keeps it in its own chunk, out of main (the blue dot needs it, little else) */
export function loadProj4(): Promise<Proj4Fn> {
  if (!loading) {
    loading = import('proj4')
      .then(m => ((m as { default?: unknown }).default ?? m) as unknown as Proj4Fn)
      .catch(e => {
        loading = null;
        throw e;
      });
  }
  return loading;
}

/** How the viewer gets proj4; specs provide the module directly */
export const PROJ4_LOADER = new InjectionToken<() => Promise<Proj4Fn>>('PROJ4_LOADER', { providedIn: 'root', factory: () => loadProj4 });
